export const getCommentKey = (blogId: number, discussionId: number, commentId: number) => 
  `${blogId}_${discussionId}_${commentId}`;